(() => {
  const init = () => {
    const modal = document.querySelector('[data-khf-authenticity-modal]');
    if (!modal || modal.dataset.ready) return;
    modal.dataset.ready = 'true';
    const openers = document.querySelectorAll('[data-khf-authenticity-open]');
    let previouslyFocused;
    const open = () => {
      previouslyFocused = document.activeElement;
      document.dispatchEvent(new CustomEvent('khf:modal:open', { detail: { source: 'important-notice' } }));
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      modal.querySelector('[data-khf-authenticity-close]')?.focus();
    };
    const close = () => {
      modal.hidden = true;
      document.body.style.overflow = '';
      previouslyFocused?.focus();
      document.dispatchEvent(new CustomEvent('khf:modal:close', { detail: { source: 'important-notice' } }));
    };
    openers.forEach((opener) => opener.addEventListener('click', (event) => { event.preventDefault(); open(); }));
    modal.querySelector('[data-khf-authenticity-close]').addEventListener('click', close);
    modal.addEventListener('click', (event) => { if (event.target === modal) close(); });
    document.addEventListener('keydown', (event) => { if (!modal.hidden && event.key === 'Escape') close(); });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
